var LOCAL_STORAGE_WISHLIST_KEY = 'shopify-wishlist';
var LOCAL_STORAGE_DELIMITER = ',';
var BUTTON_ACTIVE_CLASS = 'active';

var selectors = {
  button: '[button-wishlist]',
  grid: '[grid-wishlist]'
};

var getWishlist = function () {
  var wishlist = localStorage.getItem(LOCAL_STORAGE_WISHLIST_KEY);
  return wishlist ? wishlist.split(LOCAL_STORAGE_DELIMITER).filter(Boolean) : [];
};

var setWishlist = function (array) {
  var uniqueWishlist = array.filter(function (handle, index) {
    return handle && array.indexOf(handle) === index;
  });
  var wishlist = uniqueWishlist.join(LOCAL_STORAGE_DELIMITER);
  if (uniqueWishlist.length) localStorage.setItem(LOCAL_STORAGE_WISHLIST_KEY, wishlist);
  else localStorage.removeItem(LOCAL_STORAGE_WISHLIST_KEY);
  return wishlist;
};

var wishlistContains = function (handle) {
  return getWishlist().indexOf(handle) !== -1;
};

var updateWishlist = function (handle) {
  var wishlist = getWishlist();
  var indexInWishlist = wishlist.indexOf(handle);
  if (indexInWishlist === -1) wishlist.push(handle);
  else wishlist.splice(indexInWishlist, 1);
  return setWishlist(wishlist);
};

var resetWishlist = function () {
  return setWishlist([]);
};

var updateWishlistButtons = function (handle) {
  document.querySelectorAll(selectors.button).forEach(function (button) {
    if (button.dataset.productHandle !== handle) return;
    button.classList.toggle(BUTTON_ACTIVE_CLASS, wishlistContains(handle));
    button.setAttribute('aria-pressed', wishlistContains(handle) ? 'true' : 'false');
  });
};

var initialiseWishlistButtons = function (root) {
  var scope = root && root.querySelectorAll ? root : document;
  scope.querySelectorAll(selectors.button).forEach(function (button) {
    var handle = button.dataset.productHandle;
    if (!handle) return;
    button.classList.toggle(BUTTON_ACTIVE_CLASS, wishlistContains(handle));
    button.setAttribute('aria-pressed', wishlistContains(handle) ? 'true' : 'false');
  });
};

var setupGrid = function (grid) {
  var wishlist = getWishlist();
  var wishlistPageButton = document.querySelector('.wishlist-page');
  if (wishlistPageButton && wishlist.length) wishlistPageButton.classList.add('wishlist_exists');

  var requests = wishlist.map(function (handle) {
    return fetch('/products/' + handle + '?view=card').then(function (response) {
      if (!response.ok) throw new Error('Wishlist product could not be loaded');
      return response.text();
    });
  });

  Promise.all(requests).then(function (responses) {
    grid.innerHTML = responses.join('');
    initialiseWishlistButtons(grid);
  }).catch(function () {
    grid.classList.add('wishlist-load-error');
  });
};

document.addEventListener('DOMContentLoaded', function () {
  initialiseWishlistButtons(document);
  var grid = document.querySelector(selectors.grid);
  if (grid) setupGrid(grid);
});

document.addEventListener('click', function (event) {
  var button = event.target.closest(selectors.button);
  if (!button) return;
  event.preventDefault();
  var productHandle = button.dataset.productHandle;
  if (!productHandle) return;

  button.classList.add('loading-wishlist', 'adding-wishlist');
  updateWishlist(productHandle);
  updateWishlistButtons(productHandle);

  window.setTimeout(function () {
    button.classList.remove('loading-wishlist');
  }, 600);
  window.setTimeout(function () {
    button.classList.remove('adding-wishlist');
  }, 1000);

  document.dispatchEvent(new CustomEvent('wishlist:updated', {
    detail: {
      handle: productHandle,
      added: wishlistContains(productHandle),
      wishlist: getWishlist()
    }
  }));
});
